import { createActionGroup, props } from '@ngrx/store';

export const CommentsConfigActions = createActionGroup({
  source: 'CommentsConfig',
  events: {
    'Load Commentable Types': props<{ dataSpaceId?: number }>(),
    'Load Commentable Types Success': props<{ entityTypes: string[] }>(),
    'Load Commentable Types Failure': props<{ error: string }>()
  }
});
